import script from "./DevBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./DevBanner.vue?vue&type=script&setup=true&lang=js"

import "./DevBanner.vue?vue&type=style&index=0&id=37f44cf1&lang=css"

const __exports__ = script;

export default __exports__